import React, { useEffect, useState } from 'react';
import { email, onlyNumber } from 'app/constants/regex';
import logger from 'app/utils/logger';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { green, red2, yellow } from 'app/components/ThemeProvider/colors';
import { useEmployeeUpsert } from 'app/utils/services/clientService';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from 'app/pages/EmployeeAddPage/schema';

interface Props {
  edit?: boolean;
  userData?: any;
  rulesData?: any;
  employeeList?: any;
  businessKey?: any;
}

const useEmployeeAddPage = (props: Props) => {
  const { edit, userData, rulesData, employeeList, businessKey } = props;
  const [selectedAutoStatementPeriod, setSelectedAutoStatementPeriod] = useState(
    edit
      ? rulesData
      : {
          account: 0,
          card: 0,
          tax_orders: 0,
          salary: 0,
          payment: 0,
          loan: 0,
          deposit: 0,
          template: 0,
          requests: 0,
          trn_sign: 0,
          profile: 0,
          other: 0,
        }
  );
  const [position, setPosition] = useState(
    edit ? employeeList?.filter((item: any) => +item.id === userData?.position_id) : [{ title: 'Əməkdaş', id: 0 }]
  );
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSuccesModal, setOpenSuccessModal] = useState(false);
  const [phoneInput, setPhoneInput] = useState('');
  const [finInput, setFinInput] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [surnameInput, setSurnameInput] = useState('');
  const [fnameInput, setFnameInput] = useState('');
  const [emailInput, setEmailInput] = useState('');

  const {
    control,
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  logger.log(errors);

  const navigate = useNavigate();

  const location = useLocation();
  const lang = location.pathname.substring(0, 3);
  const data = location.state;

  const { dataEmployeeUpsert, employeeUpsertMutation, isLoadingEmployeeUpsert } = useEmployeeUpsert();

  const autostatement_types = [
    {
      title: 'Hesablar',
      label: 'account',
      id: '1',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Sərəncamlar',
      label: 'tax_orders',
      id: '2',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Kartlar',
      label: 'card',
      id: '3',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Əmək haqqı',
      label: 'salary',
      id: '4',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Köçürmə və ödənişlər',
      label: 'payment',
      id: '5',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Kreditlər',
      label: 'loan',
      id: '6',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Əmanətlər',
      label: 'deposit',
      id: '7',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Şablonlar',
      label: 'template',
      id: '8',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Sifarişlər və müraciətlər',
      label: 'requests',
      id: '9',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },
    {
      title: 'Digər',
      label: 'other',
      id: '12',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        {
          title: 'Baxış',
          value: 1,
        },
        {
          title: 'Tam giriş',
          value: 2,
        },
      ],
    },

    {
      title: 'Müştəri profili',
      label: 'profile',
      id: '11',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        // {
        //   title: 'Baxış',
        //   value: 1,
        // },
        // {
        //   title: 'Tam giriş',
        //   value: 2,
        // },
      ],
    },
    {
      title: 'İmzalanmalı əməliyyatlar',
      label: 'trn_sign',
      id: '10',
      types: [
        {
          title: 'Giriş yoxdur',
          value: 0,
        },
        // {
        //   title: 'Baxış',
        //   value: 1,
        // },
        // {
        //   title: 'Tam giriş',
        //   value: 2,
        // },
      ],
    },
  ];

  const options = [
    { value: 'asan_imza', label: 'AZAN Imza' },
    { value: 'google_otp', label: 'Google Otp' },
  ];

  const handleSend = (event: any) => {
    if (edit) {
      employeeUpsertMutation({
        businessKey: businessKey !== undefined ? businessKey : data.businessKey,
        data: {
          user_data: {
            last_name: getValues('surname'),
            first_name: getValues('name'),
            middle_name: getValues('fname'),
            pin_code: getValues('fin'),
            email: getValues('email'),
            phone: `994${phoneInput.replace(/\s+/g, '').replace(/\(/g, '').replace(/\)/g, '')}`,
            position_id: position[0].id,
          },
          rules_data: selectedAutoStatementPeriod,
        },
      });
    } else {
      employeeUpsertMutation({
        businessKey: businessKey !== undefined ? businessKey : data.businessKey,
        data: {
          user_data: {
            last_name: getValues('surname'),
            first_name: getValues('name'),
            middle_name: getValues('fname'),
            pin_code: getValues('fin'),
            email: getValues('email'),
            phone: `994${phoneInput.replace(/\s+/g, '').replace(/\(/g, '').replace(/\)/g, '')}`,
            position_id: position[0].id,
          },
          rules_data: selectedAutoStatementPeriod,
          action: 'new',
        },
      });
    }
  };

  useEffect(() => {
    if (userData !== undefined) {
      setValue('surname', userData?.last_name);
      setSurnameInput(userData?.last_name);
      setValue('name', userData?.first_name);
      setNameInput(userData?.first_name);
      setValue('fname', userData?.middle_name);
      setFnameInput(userData?.middle_name);
      setValue('fin', userData?.pin_code);
      setFinInput(userData?.pin_code);
      setValue('email', userData?.email);
      setEmailInput(userData?.email);
      setValue('phone', userData?.phone.slice(3));
      // setPhoneInput(userData?.phone.slice(3));
      const number = userData?.phone.slice(3);
      let formattedString = '';

      if (number.length <= 2) {
        formattedString = number;
      } else if (number.length <= 5) {
        formattedString = `(${number.slice(0, 2)}) ${number.slice(2)}`;
      } else if (number.length <= 7) {
        formattedString = `(${number.slice(0, 2)}) ${number.slice(2, 5)} ${number.slice(5, 7)}`;
      } else {
        formattedString = `(${number.slice(0, 2)}) ${number.slice(2, 5)} ${number.slice(5, 7)} ${number.slice(7, 9)}`;
      }

      setPhoneInput(formattedString);
      setValue('position', userData?.position_id);
    }
  }, []);

  useEffect(() => {
    if (dataEmployeeUpsert?.form_id === 'success_action') {
      setOpenSuccessModal(true);
    } else if (dataEmployeeUpsert?.error !== undefined) {
      setOpenSnackbar(true);
    }

    if (dataEmployeeUpsert?.form_id === 'success_action' && edit) {
      setOpenSnackbar(true);
    }
  }, [dataEmployeeUpsert]);

  const handleChangeAutoStatementPeriod = (e: any, id: any) => {
    setSelectedAutoStatementPeriod({ ...selectedAutoStatementPeriod, [e]: id });
  };

  const handleOnChangePhone = (event: any) => {
    const inputValue = event.target.value;
    const cleanedValue = inputValue.replace(/[^\d]/g, '');

    let formattedString = '';

    if (cleanedValue.length <= 2) {
      formattedString = cleanedValue;
    } else if (cleanedValue.length <= 5) {
      formattedString = `(${cleanedValue.slice(0, 2)}) ${cleanedValue.slice(2)}`;
    } else if (cleanedValue.length <= 7) {
      formattedString = `(${cleanedValue.slice(0, 2)}) ${cleanedValue.slice(2, 5)} ${cleanedValue.slice(5, 7)}`;
    } else {
      formattedString = `(${cleanedValue.slice(0, 2)}) ${cleanedValue.slice(2, 5)} ${cleanedValue.slice(
        5,
        7
      )} ${cleanedValue.slice(7, 9)}`;
    }
    // const pattern = /^(\d{2})(\d{3})(\d{2})(\d{2})$/;
    // const replacement = '($1) $2 $3 $4';
    //
    // const formattedString = inputValue
    //   .replace(/[a-zA-Z]/g, '')
    //   .replace(pattern, replacement)
    //   .trim();

    setPhoneInput(formattedString);
  };

  const regexForTextAZE = /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z]*$/;

  const handleChangeName = (e: any) => {
    const inputValue = e.target.value;

    if (regexForTextAZE.test(inputValue)) {
      setNameInput(inputValue);
    }
  };

  const handleChangeSurname = (e: any) => {
    const inputValue = e.target.value;

    if (regexForTextAZE.test(inputValue)) {
      setSurnameInput(inputValue);
    }
  };

  const handleChangeFname = (e: any) => {
    const inputValue = e.target.value;

    if (regexForTextAZE.test(inputValue)) {
      setFnameInput(inputValue);
    }
  };

  const handleFin = (e: any) => {
    const inputValue = e.target.value;
    const regex = /^[a-zA-Z0-9]*$/;

    if (regex.test(inputValue)) {
      setFinInput(inputValue.toUpperCase());
    }
  };

  const handleEmail = (e: any) => {
    const inputValue = e.target.value;
    const regex = /^[a-zA-Z0-9@._-]*$/;

    if (regex.test(inputValue)) {
      setEmailInput(inputValue);
    }
  };

  const submitForm = handleSubmit(handleSend);

  return {
    options,
    handleSend,
    control,
    register,
    autostatement_types,
    selectedAutoStatementPeriod,
    handleChangeAutoStatementPeriod,
    position,
    dataEmployeeUpsert,
    openSnackbar,
    setOpenSnackbar,
    setOpenSuccessModal,
    openSuccesModal,
    submitForm,
    phoneInput,
    handleOnChangePhone,
    errors,
    finInput,
    handleFin,
    handleChangeFname,
    handleChangeName,
    handleChangeSurname,
    nameInput,
    fnameInput,
    surnameInput,
    emailInput,
    handleEmail,
  };
};

export default useEmployeeAddPage;
